import {useTranslation} from "react-i18next";
import {roomViewExit} from "../../../../../redux/actions/rooms/actions.js";
import {selectActiveRoomTab} from "../../../../../redux/actions/lobby/actions.js";
import {useDispatch} from "react-redux";

const ViewRoomTab = function (props) {

    const {
        roomId,
        isActive,
    } = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(selectActiveRoomTab({roomId}));
    }

    const onClose = (event) => {
        event.stopPropagation();
        dispatch(roomViewExit({roomId}));
    }

    return (
        <div className={`header-active-game-item-wrapper ${isActive ? "active" : ""}`} onClick={handleClick}>
            <div className="header-active-game-item">
                <i className="icon-eye"/>
                <p>{t('tabs.game')} {roomId} </p>
                <i className="icon-close" onClick={(e) => onClose(e)}/>
            </div>
        </div>
    )
}

export default ViewRoomTab